import React from 'react';
import { SortDirection, GlobalFilterType } from 'utils/types';
import { VOIDS_STORES_DETAILS_SERIES } from 'apollo/queries';
import { createTableProps } from 'containers/Voids';
import OpportunityMatrixWidget from 'components/OpportunityMatrixWidget/index';
import './styles.scss';
import Formats from 'utils/formats';

interface Props {
  clientId: string;
  globalFilter: GlobalFilterType;
  onItemClick?(id: string, name: string): void;
}

const StoresOpportunityMatrixWidget: React.FC<Props> = ({
  clientId,
  globalFilter,
  onItemClick
}) => {
  const matrixTableDataResolver = (data, currentSortBy, currentSortDirection, sortHandler) => {
    return createTableProps(
      data.voidStoresDetailsSeries.data,
      data.voidStoresDetailsSeries.itemHeaders,
      [
        {
          header: 'Store',
          sortable: {
            current: currentSortBy === 'name',
            direction: currentSortDirection,
            onSort: () => sortHandler('name')
          }
        },
        {
          header: 'Voids',
          sortable: {
            current: currentSortBy === 'voids',
            direction: currentSortDirection,
            onSort: () => sortHandler('voids')
          }
        }
      ],
      [{ name: 'name' }, { name: 'voids', format: value => Formats.number(value) }],
      onItemClick ? row => onItemClick(row.storeTag, row.name) : null
    );
  };

  const dataTotalResolver = data => data.voidStoresDetailsSeries.page.totalItems;
  const dataResolver = data => data.voidStoresDetailsSeries.data;

  return (
    <div className="stores-opportunity-matrix-widget">
      <OpportunityMatrixWidget
        clientId={clientId}
        dataTotalResolver={dataTotalResolver}
        defaultSortBy="sales"
        defaultSortDirection={SortDirection.DESC}
        globalFilter={globalFilter}
        matrixTableDataResolver={matrixTableDataResolver}
        query={VOIDS_STORES_DETAILS_SERIES}
        title="Stores"
        dataResolver={dataResolver}
      />
    </div>
  );
};

export default StoresOpportunityMatrixWidget;
